<template>
    <div>
        <div class="page-title">
            <h4 v-if='this.employee'> {{(parseInt(this.employee.type) === 1) ? (this.employee.first_name + ' ' + this.employee.last_name) : ((parseInt(this.employee.type) === 2) ? this.employee.company_name : '')}}</h4>
        </div>
        <div class="table-header edit-header">
            <div class="search-box" v-if="$can(['update employee'])">
                <router-link :to="`/employees/${employee.id}/edit`">
                    <button type="button" class="add-user edit-button">
                        <i class="far fa-edit"></i>
                        <span> {{$t('placeholder.editeaza')}} </span>
                    </button>
                </router-link>
            </div>
        </div>
        <form class="add-user-form">
            <div class="row">
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_1" :key="input_field.id">
                                  <div class="view-info-wrapper" v-if="!input_field.personType || parseInt(input_field.personType) === parseInt(employee.type)">
                                    <div class="contact-design">
                                        <i :class="input_field.icon"></i>
                                        <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12">
                    <div class="account-detail-box">
                        <ul class="account-detail-list">
                            <sequential-entrance fromTop delay="70">
                                <li v-for="input_field in input_fields.column_2" :key="input_field.id">
                                  <div class="view-info-wrapper">
                                    <div class="contact-design">
                                        <i v-bind:class="input_field.icon"></i>
                                        <span> {{input_field.labelName}} </span>
                                    </div>
                                    <p> {{input_field.inputValue}} </p>
                                  </div>
                                </li>
                            </sequential-entrance>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-xl-12 col-md-12" v-if="this.employee.user_type">
                    <div class="location-header">
                        <h4> {{$t('txt.selecteazaTipAngajat')}} </h4>
                    </div>
                    <ul class="subtype-view-list">
                        <li class="subtype-list-item" v-for="types in this.employee.user_type" :key="types.id">
                            <i class="fas fa-user-tag"></i>
                            <span>{{types.types.type}}</span>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('txt.documente')}} </h4>
                    </div>
                </div>
                <div class="col-xl-12 col-lg-12 col-md-12 col-12">
                    <div class="inner-location-group doc-group">
                        <div class="documents-list" v-if="this.employee">
                            <div class="document-box" v-for="file in this.employee.files" :key="file.id">
                                <div class="document-content">
                                    <i class="far fa-file-alt"></i>
                                    <section v-if="mimes.includes(file.mime)">
                                        <a v-bind:href="file.link" target="_blank"> {{ file.file_name }} </a>
                                    </section>
                                    <section v-else>
                                        <a :href="file.link" download> {{ file.file_name }} </a>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-xl-12 col-md-12" v-if="warehouses">
                    <div class="location-header">
                        <h4> Depozite </h4>
                    </div>
                    <ul class="warehouses-list">
                        <li v-for="warehouse in warehouses" :key="warehouse.id">
                            <i class="fas fa-warehouse"></i>
                            <span> {{warehouse.name}} </span>
                        </li>
                    </ul>
                </div>
                <div class="col-12">
                    <div class="location-header">
                        <h4> {{$t('placeholder.notite')}} </h4>
                    </div>
                    <div class="inner-location-group">
                        <textarea v-model="this.employee.notes" name='notes' disabled></textarea>
                        <div class="save-contact-buttons">
                        </div>
                    </div>
                </div>
                <!--<div class="col-12" v-if="!this.employee.is_transformed_in_contact">
                    <div class="save-as-contact">
                        <button type="button" @click='saveAsContact()' :disabled="this.$store.state.loading">
                            <i class="fas fa-save"></i>
                            {{$t('txt.salveazaCaSiContact')}}
                        </button>
                    </div>
                </div>-->
                <table class="table app_table">
                    <thead>
                    <tr class="app_table_header">
                        <th scope="col">
                            {{$t('tableHeader.numePartener')}}
                        </th>
                        <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
                    </tr>
                    </thead>
                    <tbody v-if="this.employee">
                    <tr  v-for="partners in this.employee.partners" :key="partners.id">
                        <td :tableheadData="$t('tableHeader.numePartener')"> {{partners.first_name}} {{partners.last_name}} </td>
                        <td :tableheadData="$t('tableHeader.optiuni')" class="options-case">
                            <router-link :to="{ name: 'viewpartner', params: { id: partners.id }}" class="view-user"
                                         data-placement="top" data-toggle="tooltip" :title="$t('placeholder.vizualizeaza')">
                                <i class="fas fa-eye"></i>
                            </router-link>
                        </td>
                    </tr>
                    </tbody>
                    <tbody v-else>
                    <tr>
                        <td colspan="8" v-if="this.$store.state.loading">{{$t('txt.loading')}}</td>
                        <td colspan="8" v-else>{{$t('errors.emptyResult')}}</td>
                    </tr>
                    </tbody>
                    <tfoot v-if="this.employee">
                    <tr class="app_table_header">
                        <th scope="col">
                            {{$t('tableHeader.numePartener')}}
                        </th>
                        <th scope="col"> {{$t('tableHeader.optiuni')}}</th>
                    </tr>
                    </tfoot>
                </table>
            </div>
        </form>
    </div>
</template>

<script>

import EmployeesService from '../../api-services/employees.service.js'

export default {
  name: 'viewemployee',
  data () {
    return {
      employee: {
        id: null,
        type: null,
        first_name: null,
        last_name: null,
        company_name: null,
        email: null,
        phone: null,
        county: null,
        city: null,
        address: null,
        cui: null,
        nr_reg: null,
        bank: null,
        site: null,
        delegat: null,
        date_corespondenta: null,
        notes: null,
        has_account: null,
        locations: null,
        contacts: null,
        files: null
      },
      mimes: ['image/jpeg', 'image/jpg', 'image/png', 'application/pdf'],
      warehouses: []
    }
  },
  methods: {
    getEmployee () {
      EmployeesService.get(this.$route.params.id)
        .then((response) => {
          this.$store.dispatch('hideLoading')
          this.employee = response.data.data
          this.warehouses = response.data.data.warehouses
        })
        .catch((error) => {
          this.$store.dispatch('hideLoading')
          console.log(error)
        })
    },
    saveAsContact () {
      EmployeesService.transformInContact(this.$route.params.id)
        .then((response) => {
          this.$notify({
            group: 'succes',
            type: 'success',
            title: this.$t('txt.succes'),
            text: this.$t('success.contactAdaugat'),
            'animation-type': 'css'
          })
          this.employee.contacts.push(response.data.data)
          this.employee.is_transformed_in_contact = true
          window.scrollTo(0, 0)
        })
        .catch((error) => {
          console.log(error)
          this.$notify({
            group: 'error',
            type: 'error',
            title: this.$t('errors.errorTitle'),
            text: error.response.data.error,
            'animation-type': 'css'
          })
        })
    }
  },
  computed: {
    input_fields () {
      return {
        column_1: [
          {
            inputName: 'type',
            labelName: this.$t('txt.tipulDePersoana'),
            inputValue: (this.employee) ? (parseInt(this.employee.type) === 2) ? this.$t('txt.persJuridica') : this.$t('txt.persFizica') : null,
            icon: 'fas fa-user-tag'
          },
          {
            inputName: 'first_name',
            labelName: this.$t('placeholder.nume'),
            inputValue: (this.employee) ? this.employee.first_name : null,
            icon: 'fas fa-signature',
            personType: 1
          },
          {
            inputName: 'last_name',
            labelName: this.$t('placeholder.prenume'),
            inputValue: (this.employee) ? this.employee.last_name : null,
            icon: 'fas fa-signature',
            personType: 1
          },
          {
            inputName: 'cnp',
            labelName: this.$t('placeholder.CNP'),
            inputValue: (this.employee) ? this.employee.cnp : null,
            icon: 'far fa-id-card',
            personType: 1
          },
          {
            inputName: 'ci_series',
            labelName: this.$t('placeholder.Serie'),
            inputValue: (this.employee) ? this.employee.ci_series : null,
            icon: 'far fa-id-card',
            personType: 1
          },
          {
            inputName: 'ci_number',
            labelName: this.$t('placeholder.CI'),
            inputValue: (this.employee) ? this.employee.ci_number : null,
            icon: 'far fa-id-card',
            personType: 1
          },
          {
            inputName: 'phone',
            labelName: this.$t('placeholder.telefon'),
            inputValue: (this.employee) ? this.employee.phone : null,
            icon: 'fas fa-phone'
          },
          {
            inputName: 'company_name',
            labelName: this.$t('placeholder.numeCompanie'),
            inputValue: (this.employee) ? this.employee.company_name : null,
            icon: 'fas fa-building',
            personType: 2
          },
          {
            inputName: 'cui',
            labelName: this.$t('placeholder.cui'),
            inputValue: (this.employee) ? this.employee.cui : null,
            icon: 'fas fa-scroll',
            personType: 2
          },
          {
            inputName: 'nr_reg',
            labelName: this.$t('placeholder.nrRegCom'),
            inputValue: (this.employee) ? this.employee.nr_reg : null,
            icon: 'fas fa-cash-register',
            personType: 2
          },
          {
            inputName: 'bank',
            labelName: this.$t('placeholder.banca'),
            inputValue: (this.employee) ? this.employee.bank : null,
            icon: 'fas fa-piggy-bank'
          }
        ],
        column_2: [
          {
            inputName: 'county',
            labelName: this.$t('placeholder.judet'),
            inputValue: (this.employee.county) ? this.employee.county.name : null,
            icon: 'fas fa-map-marker-alt',
            validationRules: 'alpha'
          },
          {
            inputName: 'city',
            labelName: this.$t('placeholder.oras'),
            inputValue: (this.employee.city) ? this.employee.city.name : null,
            icon: 'fas fa-map-marker-alt',
            validationRules: 'alpha'
          },
          {
            inputName: 'address',
            labelName: this.$t('placeholder.adresa'),
            inputValue: (this.employee) ? this.employee.address : null,
            icon: 'fas fa-map-marker-alt'
          },
          {
            inputName: 'email',
            labelName: this.$t('placeholder.email'),
            inputValue: (this.employee) ? this.employee.email : null,
            icon: 'fas fa-envelope'
          },
          {
            inputName: 'delegat',
            labelName: this.$t('placeholder.delegat'),
            inputValue: (this.employee) ? this.employee.delegat : null,
            icon: 'fas fa-user-tie'
          },
          {
            inputName: 'date_corespondenta',
            labelName: this.$t('placeholder.dateDeCorespondenta'),
            inputValue: (this.employee) ? this.employee.date_corespondenta : null,
            icon: 'fas fa-info'
          },
          {
            inputName: 'site',
            labelName: this.$t('placeholder.siteWeb'),
            inputValue: (this.employee) ? this.employee.site : null,
            icon: 'far fa-window-maximize'
          },
          {
            inputName: 'created_at',
            labelName: this.$t('txt.dataAdaugare'),
            inputValue: (this.employee) ? this.employee.created_at : null,
            icon: 'fas fa-calendar-alt'
          }
        ]
      }
    }
  },
  mounted () {
    this.getEmployee()
  }
}
</script>
